import * as React from 'react';

const CustomIcon = React.forwardRef(({ image, style, className, ...restProps }, ref) => {
  return (
    <span
      ref={ref}
      role="img"
      aria-label="custom-icon"
      className={className}
      style={{
        display: 'inline-block',
        width: '1.3em',
        height: '1.3em',
        lineHeight: 0,
        verticalAlign: '-0.125em',
        backgroundImage: `url(${image})`,
        backgroundSize: 'contain',
        backgroundRepeat: 'no-repeat',
        backgroundPosition: 'center',
        ...style,
      }}
      {...restProps}
    />
  );
});

CustomIcon.displayName = 'CustomIcon';

export default CustomIcon;
